import { ReactNode } from "react"
import { DateTime } from "@/lib/dates"

// UI
import { StatusMessage } from "./StatusMessage"

// Icons
import { FiActivity, FiLogIn, FiSunrise, ScaleIcon } from "@/lib/icons"

interface TimelineWrapperProps {
	className?: string
	children: ReactNode
}

export const TimelineWrapper = ({
	className = "",
	...rest
}: TimelineWrapperProps) => (
	<ul className={`${className} space-y-6 overflow-hidden`} {...rest} />
)

const getIcon = (type: string) => {
	if (type === "investment") {
		return <ScaleIcon className="w-6 text-gray-500" />
	}

	if (type === "login") {
		return <FiLogIn size={16} className="text-gray-500" />
	}

	if (type === "project") {
		return <FiSunrise size={16} className="text-gray-500" />
	}

	return <FiActivity size={16} className="text-gray-500" />
}

interface TimelineItemProps {
	type: string
	date: DateTime
	content: string
	position?: "end"
}

export const TimelineItem = ({
	type,
	content,
	position,
}: TimelineItemProps) => {
	return (
		<li className="relative">
			{position !== "end" && <Divider />}
			<div className="flex items-start space-x-3">
				<IconBubble icon={getIcon(type)} />
				<div className="timeline-item-content flex-1 pt-1.5 text-sm text-gray-500">
					<StatusMessage content={content} />
				</div>
			</div>
		</li>
	)
}

const Divider = () => (
	<span
		className="absolute top-10 -bottom-4 left-4 -ml-px w-0.5 bg-gray-200"
		aria-hidden="true"
	/>
)

const IconBubble = ({ icon }: { icon: ReactNode }) => (
	<div className="flex size-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
		{icon}
	</div>
)
